import React, { CSSProperties } from 'react';
import { forwardRefPolymorphic } from "@mrocket/utils";
import { Color, Font, SizeNumber } from "@mrocket/styles";
import { TextRoot } from "./Text.styles";
import { Property } from 'csstype';

export interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: SizeNumber,
  align?: Property.TextAlign,
  font?: Font,
  weight?: Property.FontWeight,
  decoration?: Property.TextDecoration,
  transform?: Property.TextTransform,
  color?: Color
}

export const Text = forwardRefPolymorphic<'div', TextProps>((
  {
    color = '1',
    ...props
  },
  ref
) => {

  return (
    <TextRoot
      ref={ref}
      color={color}
      {...props}
    />
  );
});

Text.displayName = 'Text'



